import state from './moduleCustomerGroupState.js'
import mutations from './moduleCustomerGroupMutations.js'
import actions from './moduleCustomerGroupActions.js'
import getters from './moduleCustomerGroupGetters.js'

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
